/**
 * Pure logic functions for the HIIT Quick Start timer.
 * No React, no side effects — easy to unit-test.
 */

/** Total workout duration in minutes. */
export function calcHIITDuration(work, rest, rounds) {
  return Math.round((work + rest) * rounds / 60);
}

/** Format integer seconds as "MM:SS". Clamps to 0. */
export function formatPhaseTime(seconds) {
  const s = Math.max(0, seconds);
  const m = Math.floor(s / 60);
  const sec = s % 60;
  return `${String(m).padStart(2, '0')}:${String(sec).padStart(2, '0')}`;
}

/**
 * Compute the next timer state after a phase ends.
 * @param {{ phase: 'work'|'rest', curRound: number, rounds: number, work: number, rest: number }} params
 * @returns {{ phase: 'work'|'rest', curRound: number, timeLeft: number, done: boolean }}
 */
export function advancePhase({ phase, curRound, rounds, work, rest }) {
  if (phase === 'work') {
    return { phase: 'rest', curRound, timeLeft: rest, done: false };
  }
  const nextRound = curRound + 1;
  if (nextRound > rounds) {
    return { phase: 'work', curRound: nextRound, timeLeft: work, done: true };
  }
  return { phase: 'work', curRound: nextRound, timeLeft: work, done: false };
}

/**
 * Percent of the total workout that has elapsed (0–100).
 * Used for the overall progress label in the timer screen.
 */
export function calcOverallProgress(phase, curRound, work, rest, rounds, timeLeft) {
  const totalSecs = (work + rest) * rounds;
  if (totalSecs === 0) return 0;
  const elapsed =
    (curRound - 1) * (work + rest) +
    (phase === 'work' ? work - timeLeft : work + (rest - timeLeft));
  return Math.min(100, Math.round((elapsed / totalSecs) * 100));
}
